import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { IonContent, ModalController } from '@ionic/angular';
import { BotAssistenzaService, MessaggioChat } from 'src/app/services/common/bot-assistenza.service';
import { DemoFlowService } from 'src/app/services/common/demo-flow.service';

/**
 * Chat con l'assistente nella demo su telefono: un foglio che si apre dal basso
 * e si trascina, come il riepilogo del carrello nello shop.
 *
 * È la stessa chat del desktop e del sito: stesso servizio, stessa
 * conversazione, stesso id_browser. Cambia solo il vestito, perché sul telefono
 * un pannello ancorato in un angolo non ci sta.
 */
@Component({
  selector: 'app-demo-chat-mobile',
  templateUrl: './demo-chat.component.html',
  styleUrls: ['./demo-chat.component.scss']
})
export class DemoChatMobileComponent implements OnInit {

  @ViewChild('flusso') flusso: IonContent;

  messaggi: MessaggioChat[] = [];
  testo = '';
  botPensa = false;

  constructor(
    private cd: ChangeDetectorRef,
    private modalCtrl: ModalController,
    private bot: BotAssistenzaService,
    private demoFlow: DemoFlowService
  ){}

  async ngOnInit(){
    try{
      // Chi ha già scritto sul sito o nella demo riprende da dove era.
      const conv = await this.bot.conversazione();
      if(conv.messaggi.length) this.messaggi = conv.messaggi;
    }catch(err){
      console.error(err);
    }
    if(!this.messaggi.length){
      this.messaggi = [{ da: 'bot', testo: 'Ciao! Sono l\'assistente di Balin 👋 Guarda pure la demo con calma: se hai una domanda scrivimi qui.' }];
    }
    this.cd.detectChanges();
    this.inFondo();
  }

  chiudi(){
    this.modalCtrl.dismiss();
  }

  /** "Prova gratuita": la stessa strada del pulsante sopra la barra. */
  apriProva(){
    this.chiudi();
    this.demoFlow.vaiAllaRichiestaProva();
  }

  async manda(){
    const t = (this.testo || '').trim();
    if(!t || this.botPensa) return;
    this.messaggi.push({ da: 'io', testo: t });
    this.testo = '';
    this.botPensa = true;
    this.cd.detectChanges();
    this.inFondo();

    const esito = await this.bot.invia(t);
    this.botPensa = false;
    if(esito.risposta) this.messaggi.push({ da: 'bot', testo: esito.risposta });
    else if(esito.passatoAOperatore) this.messaggi.push({ da: 'sistema', testo: 'Conversazione in mano a un operatore (' + esito.passatoAOperatore + ').' });
    else if(esito.errore) this.messaggi.push({ da: 'sistema', testo: esito.errore });
    if(esito.troncata) this.messaggi.push({ da: 'sistema', testo: 'Attenzione: la risposta è stata troncata.' });
    this.cd.detectChanges();
    this.inFondo();
  }

  /** L'ultimo messaggio sempre a vista. */
  private inFondo(){
    setTimeout(() => this.flusso?.scrollToBottom(200), 60);
  }
}
